import { useQuery } from '@tanstack/react-query';
import { getPrivacyPolicy } from 'services/content/privacy-policy/privacy-policy';

export const usePrivacyPolicy = () => {
  return useQuery({
    queryKey: ['use-privacy-policy'],
    queryFn: getPrivacyPolicy,
  });
};
